/**
 * Local-dev personas for the localauth0 login picker (ONE-7804).
 *
 * ⚠️ These `memberId`s MUST match rows seeded in
 * `../hogc-one-api/local/mysql/seed/2_data.sql`. localauth0 has no user store
 * — it holds a single, mutable identity — so the picker cannot read the list
 * from the auth server or the database. The two lists are kept in sync BY HAND.
 * If you add a persona here, seed the matching member there (and vice versa).
 *
 * Two independent dimensions are represented, and they are easy to conflate:
 *   - `member_cg_zone.roleId` -> pastoral rank, drives resource filtering.
 *   - `member_leadership_role` -> `isLeader`, drives leader-only content.
 * `dev.ptl` and `dev.cgl` both hold an active leadership row (that is what a
 * real PTL and CGL look like) and differ only on pastoral rank; `dev.r` is the
 * only persona with `isLeader` false, so it is the one that proves leader-only
 * content is gated at all.
 */

/**
 * @typedef {Object} LocalPersona
 * @property {string} id       Stable key for the picker.
 * @property {number} memberId Must exist in the API's local seed.
 * @property {string} username Mapped to the `nickname` claim -> req.username.
 * @property {string} label    Human-readable option in the picker.
 * @property {string} email
 * @property {string} description What this persona is useful for.
 */

/** @type {LocalPersona[]} */
export const LOCAL_PERSONAS = [
  {
    id: 'dev.r',
    memberId: 568,
    username: 'dev.r',
    label: 'dev.r — Regular member',
    email: 'dev.r@gmail.com',
    description: 'Baseline member. No leadership. Onboarding complete.',
  },
  {
    id: 'dev.ptl',
    memberId: 569,
    username: 'dev.ptl',
    label: 'dev.ptl — PTL',
    email: 'dev.ptl@gmail.com',
    description: 'Leader (isLeader true) at pastoral rank PTL (role.sort 6).',
  },
  {
    id: 'dev.cgl',
    memberId: 570,
    username: 'dev.cgl',
    label: 'dev.cgl — CGL (leader)',
    email: 'dev.cgl@gmail.com',
    description: 'Leader (isLeader true) at pastoral rank CGL (role.sort 11) — highest here.',
  },
];

/**
 * Look up a persona by its id.
 * @param {string} id
 * @returns {LocalPersona | undefined}
 */
export function findPersona(id) {
  return LOCAL_PERSONAS.find(persona => persona.id === id);
}
